import style from "./style.css";
import GameStatusInfo from "../game-status-info";
import IconBorder from "../border-icon";

const GameCard = ({ game, isLoading }) => {
  if (isLoading) {
    return (
      <div className={style.game_wrapper_loading}>
        <span className={style.home} />
        <IconBorder isLoading={true} />
        <GameStatusInfo />
        <IconBorder isLoading={true} />
        <span className={style.away} />
      </div>
    );
  }

  if (!game) return undefined;
  return (
    <div className={isLoading ? style.game_wrapper_loading : style.game_wrapper}>
      <span className={style.home}>{game.homeTeam?.name}</span>
      <IconBorder imgSrc={game.homeTeam?.logo} />
      <GameStatusInfo game={game} />
      <IconBorder imgSrc={game.awayTeam?.logo} />
      <span className={style.away}>{game.awayTeam?.name}</span>
    </div>
  );
};

export default GameCard;
